import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";

function KpiCard({ label, value }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">{label}</Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>{value}</Typography>
      </CardContent>
    </Card>
  );
}

export function FinanceSecondaryKpis({ kpis }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="N° Ventas" value={String(kpis?.sales_count ?? 0)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Ticket promedio (PEN)" value={formatPen(kpis?.avg_ticket_pen)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Cashflow (PEN)" value={formatPen(kpis?.cashflow_pen)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Utilidad bruta (PEN)" value={formatPen(kpis?.gross_profit_pen)} />
      </Grid>
    </Grid>
  );
}
